// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio {\r\n\tborder: solid 1px #FFFFFF;\r\n\tborder-radius: 6px;\r\n\r\n\tdisplay: inline-block;\r\n\tpadding: 5px 0 5px 10px;\r\n    margin: 0 15px 0 0;\r\n}\r\n/* .radio:hover {\r\n\tcursor: pointer;\r\n\tborder-color: #EAEAEA;\r\n} */\r\n.radio > label:hover, .radio > input:hover {\r\n\tcursor: pointer;\r\n}\r\n\r\n.radio-checked {\r\n    border-color: var(--primary);\r\n}\r\n\r\n.radio-checked > input[type=\"radio\"] {\r\n\taccent-color: var(--primary);\r\n}\r\n", ""]);
// Exports
module.exports = exports;
